'use client'
import Loader from '@/components/atoms/Loader'
import { showUIAlert, useSubmitForm } from '@/components/atoms/forms/FormUtils'
import { RequestedFormsConfigType, useMergeFormsConfig } from '@/components/atoms/forms/InputConfigs'
import { userService } from '@/services/UserService'
import { useRouter } from 'next/navigation'
import { HTMLAttributes } from 'react'
import BaseFormStyled from '../elements/BaseFormStyled'
import FormBody from '../elements/FormBody'

interface Props extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

const PasswordRecovery = ({ className, ...props }: Props) => {
  const router = useRouter()
  const baseFormInputConfigurations: RequestedFormsConfigType = [
    {
      name: 'email',
      className: 'flex-1 text-sm',
      label: 'Email',
      placeholder: 'Type your email'
    }
  ]
  const inputConfiguration = useMergeFormsConfig(baseFormInputConfigurations)

  const handleForgotPassword = async ({ email }: Record<string, string>) => {
    await userService.resetPassword({
      params: {
        body: { email }
      }
    })
  }

  const { handleSubmit, isLoading } = useSubmitForm({
    service: handleForgotPassword,
    aditionalPayloadData: {},
    onErrorCallback: () => {
      showUIAlert({
        title: 'Error',
        titleText: 'If the email is registered, you will receive an email with instructions to reset your password'
      })
    },
    onSuccessCallback: ({ reset }) => {
      showUIAlert({
        title: 'Success',
        titleText: 'If the email is registered, you will receive an email with instructions to reset your password',
        didDestroy: () => {
          router.push('/auth/credentials-signin')
        }
      })
      reset()
    }
  })

  const message = isLoading ? 'Loading...' : 'Request link'
  return (
    <div className={className} {...props}>
      {isLoading && <Loader />}
      <FormBody className="flex flex-col">
        <BaseFormStyled
          className="flex-1"
          InputsConfig={inputConfiguration}
          onSubmit={handleSubmit}
          submitText={message}
          submitClassName="text-lg w-full"
          cancelMessage="Back to login"
          onCancel={() => {
            router.push('/auth/login')
          }}
        />
      </FormBody>
    </div>
  )
}

export default PasswordRecovery
